export class NetLerp {
  constructor(delay = 200, capacity = 32) {
    this.delay = delay
    this.capacity = capacity
    this.xs = new Float64Array(capacity)
    this.ys = new Float64Array(capacity)
    this.ts = new Float64Array(capacity)
    this.head = 0 // next write index
    this.count = 0
  }

  _idx(i) {
    return (this.head - this.count + i + this.capacity) % this.capacity
  }

  push(x, y, t = performance.now()) {
    // Drop duplicates that arrive at virtually the same time (< 1ms apart)
    if (this.count > 0) {
      const lastIdx = this._idx(this.count - 1)
      if (t - this.ts[lastIdx] < 1) {
        // Overwrite the last entry instead of adding a new one
        this.xs[lastIdx] = x
        this.ys[lastIdx] = y
        return
      }
    }
    const idx = this.head
    this.xs[idx] = x
    this.ys[idx] = y
    this.ts[idx] = t
    this.head = (this.head + 1) % this.capacity
    if (this.count < this.capacity) this.count++
  }

  snap(x, y, t = performance.now()) {
    this.count = 0
    this.head = 0
    this.push(x, y, t)
  }

  getPosition(now = performance.now()) {
    if (this.count === 0) return null

    const renderTime = now - this.delay

    // Find last snapshot at or before renderTime
    let i = -1
    for (let j = 0; j < this.count; j++) {
      const idx = this._idx(j)
      if (this.ts[idx] <= renderTime) i = j
      else break
    }

    // Before first snapshot — hold at earliest position
    if (i === -1) {
      const idx = this._idx(0)
      return { x: this.xs[idx], y: this.ys[idx] }
    }

    // Prune everything before i
    if (i > 0) this.count -= i

    const aIdx = this._idx(0)

    // No next snapshot — hold at last known position
    if (this.count < 2) return { x: this.xs[aIdx], y: this.ys[aIdx] }

    const bIdx = this._idx(1)
    const dt = this.ts[bIdx] - this.ts[aIdx]
    if (dt <= 0) return { x: this.xs[bIdx], y: this.ys[bIdx] }

    const t = Math.min((renderTime - this.ts[aIdx]) / dt, 1)

    return {
      x: this.xs[aIdx] + (this.xs[bIdx] - this.xs[aIdx]) * t,
      y: this.ys[aIdx] + (this.ys[bIdx] - this.ys[aIdx]) * t,
    }
  }

  settled(now = performance.now()) {
    if (this.count === 0) return true
    if (this.count === 1) return now - this.delay >= this.ts[this._idx(0)]
    return false
  }
}
